import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

// Second step for signups that have no payment page (pay at club / waitlist / free).
export const SignupConfirmDialog = ({ request, onConfirm, onClose, L, price, dateLabel }) => {
  const ev = request?.ev;
  const kind = request?.kind;
  const how = kind === 'waitlist'
    ? L('You will be added to the waitlist (free).', 'Du kommst auf die Warteliste (kostenlos).')
    : kind === 'pay_at_club'
      ? L(`Pay ${price} CHF at reception on arrival.`, `Bezahlung ${price} CHF vor Ort an der Rezeption.`)
      : L('Free event.', 'Kostenloses Event.');
  return (
    <AlertDialog open={!!request} onOpenChange={(o) => { if (!o) onClose(); }}>
      <AlertDialogContent data-testid="signup-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {kind === 'waitlist' ? L('Join the waitlist?', 'Auf die Warteliste?') : L('Sign up for this event?', 'Für dieses Event anmelden?')}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-1 text-slate-700" data-testid="signup-confirm-details">
              <p className="font-bold text-slate-900">{ev?.title}</p>
              <p>{dateLabel || ev?.date} · {ev?.start_time}{ev?.end_time ? `–${ev.end_time}` : ''}</p>
              <p>{how}</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="signup-confirm-cancel">{L('Cancel', 'Abbrechen')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-emerald-500 hover:bg-emerald-600 font-bold" data-testid="signup-confirm-yes">
            {kind === 'waitlist' ? L('Yes, join waitlist', 'Ja, auf Warteliste') : L('Yes, sign me up', 'Ja, anmelden')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
